<template>
  <div class="pusher">
    <!-- Page Contents -->
    <div class="ui inverted vertical center aligned segment">

      <div class="ui container">
        <div class="ui large secondary inverted pointing menu">
          <a class="toc item">
            <i class="sidebar icon"></i>
          </a>


          <router-link :to="{name: 'Hello'}" class="item">About</router-link>
          <!-- <a href="/#/#data-section" class="item">Data</a> -->
          <router-link :to="{name: 'Pricing'}" class="item">Pricing</router-link>
          <div class="right item">
            <router-link :to="{name: 'Login'}" class="ui inverted button">Log In</router-link>
            <!-- <router-link :to="{name: 'Signup'}" class="ui inverted button">Sign Up</router-link> -->
          </div>
        </div>
      </div>
    </div>
    <div class="ui vertical aligned segment">
      <div id="pricing-section" class="ui text container">
        <h1>Select plan</h1>

        <form class="ui form" id="payment-form" onsubmit="return false">

        <p>FIXME: {{plan}}</p>

          <div class="field">
            <!--
            <div class="ui cards">
              <div class="card" id="us-all">
                <div class="content">
                  <i class="right floated mini ui image flag us"></i>
                  <div class="header">
                    Entire US
                  </div>
                  <div class="meta">
                    Every county and every state
                  </div>
                  <div class="description">
                    Download either for all of the US or per-county.
                  </div>
                </div>
                <div class="extra content">
                  <div class="ui one buttons">
                    <div class="ui green button" :class="{basic: isCounty}">$2000</div>
                  </div>
                </div>
              </div>
              <div class="card" id="county">
                <div class="content">
                <i class="right floated mini ui image add to cart icon"></i>
                  <div class="header">
                    Per-county ($250)
                  </div>
                  <div class="meta">
                    Add as many counties as you need.
                  </div>
                  <div class="description">
                    Add more counties or migrate to the entire US plan later.
                  </div>
                </div>
                <div class="extra content">
                  <div class="ui buttons">
                    <div class="ui grey button aligned center" :class="{basic: !isCounty}">$250 each</div>
                  </div>
                </div>
              </div>
            </div>-->

            <label>Plan</label>
            <div id="plan-select" class="ui fluid selection dropdown">

              <input v-model="plan" type="hidden" name="plan">
              <i class="dropdown icon"></i>
              <div class="default text">Select Plan</div>
              <div class="menu">
                <div class="item" data-value="us-all">
                  <i class="us flag"></i>
                  All of the US ($2000)
                </div>
                <div class="item" data-value="county">
                  <i class="add to cart icon"></i>
                  Per county ($250)
                </div>
              </div>
            </div>

            <label v-if="countyPlan">Select counties</label>

            <select id="county-select" class="ui fluid search dropdown" multiple="" v-model="counties" v-if="countyPlan">
              <option value="">State</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
            </select>
          </div>

          <div class="field">
            <label>Email</label>
            <input type="text" name="email" placeholder="your-email@example.com" v-model="email" @click="emailComplete">
          </div>
          <div class="field">
            <label>Name</label>
            <input type="text" name="name" placeholder="Joe Bloggs" v-model="name">
          </div>
          <div class="field">
            <label>Phone (optional)</label>
            <input type="text" name="phone" placeholder="123-456-7890" v-model="phone">
          </div>
          <div class="field">
            <label>Password</label>
            <input type="password" name="password" placeholder="Password" v-model="password">
          </div>

          <div class="form-row">
            <label for="card-element">
              Credit or debit card
            </label>
            <div id="card-element">
              <!-- a Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display form errors -->
            <div id="card-errors" role="alert"></div>
          </div>
          <br />

          <div class="field">
            <div class="ui checkbox">
              <input type="checkbox" name="terms" v-model="terms">
              <label>I agree to the Terms and Conditions</label>
            </div>
          </div>

          <div class="ui negative message" v-if="errorMessage">
            <i class="close icon"></i>
            <div class="header">
              Oh no! There was an error during signup
            </div>
            <p>{{errorMessage}}</p>
          </div>

          <button class="ui button primary approve" type="submit" :class="{'disabled': !filledIn || submitted}">Submit</button>
          <div class="ui error message"></div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
var $ = window.$ // require('jQuery') would be better?
var Stripe = window.Stripe
import Vue from 'vue'

export default {
  name: 'signup',
  data () {
    return {
      plan: 'us-all',
      counties: [],
      name: '',
      email: '',
      password: '',
      phone: '',
      stripeToken: '',
      terms: false,
      stripeZipFilled: false,

      submitted: false,
      errorMessage: ''
    }
  },
  computed: {
    countyPlan: function () { return this.plan === 'county' },
    filledIn: function () {
      // console.log(this)
      return !!this.plan && !!this.name && !!this.email && !!this.password && !!this.setZipFilled && this.terms
    }
  },
  methods: {
    doThis: function (event, callback) {
      console.log('hi')
      console.log(this)
      this.$once('click', this.foo)
    },
    foo: function () {
      console.log('foo')
    },
    emailComplete: function () {
    },
    setZipFilled: function (postalCode) {
      // NOTE is better way to see card is filled in?
      this.stripeZipFilled = String(postalCode).length === 5
    },
    stripeSubmit: function () {
    },
    create: function (token) {
      var that = this
      // NOTE: this is a workaround for only submitting the form once
      // most likely it would be better to enforce once only clicking...
      var otherSubmitInProgress = this.submitted
      this.submitted = true
      this.$forceUpdate()
      Vue.nextTick(function () {
        var validatedForm = $('#payment-form.ui.form').form('validate form')
        if (that.filledIn && !otherSubmitInProgress && validatedForm) {
          console.log('SUBMIT')
          console.log(that.email)
          console.log(token)

          $.post({
            url: '/api/signup',
            data: {
              plan: that.plan,
              counties: that.counties.toString(),
              email: that.email,
              password: that.password,
              phone: that.phone,
              stripeToken: token.id
            },
            success: function (response) {
              console.log('success')
              that.$router.push({name: 'Dashboard'})
            },
            error: function (error) {
              console.log(error)
              that.errorMessage = error.responseJSON.error
              that.submitted = false  // TODO setTimeout here?

              // if it's credit card we should... do someething abuot it? focus or something?
            }
          })
        }
        if (!validatedForm) {
          console.log('invalid form')
          that.submitted = false
        }
      })
    },
    submitClick: function (event) {
      var that = this

      if (this.submitInProgress) {
        console.log('submit')
        this.timer = setTimeout(function () {
          that.submitInProgress = false
        }, 700)
      } else {
        clearTimeout(that.timer)
        console.log('double click')
        that.submitInProgress = true
      }
    }
  },
  mounted: function () {
    var that = this

    $('.ui.sidebar')
      .sidebar('attach events', '.toc.item')

    $('.ui.dropdown')
      .dropdown()

    $('#county-select.ui.dropdown')
      .dropdown({message: {noResults: 'No results found.'}})

    $('#payment-form.ui.form')
      .form({
        fields: {
          name: {
            identifier: 'name',
            rules: [
              {
                type: 'empty',
                prompt: 'Please enter your name'
              }
            ]
          },
          email: {
            identifier: 'email',
            rules: [
              {
                type: 'email',
                prompt: 'Please enter a valid email address'
              }
            ]
          },
          password: {
            identifier: 'password',
            rules: [
              {
                type: 'empty',
                prompt: 'Please enter a password'
              },
              {
                type: 'minLength[10]',
                prompt: 'Your password must be at least {ruleValue} characters'
              }
            ]
          },
          terms: {
            identifier: 'terms',
            rules: [
              {
                type: 'checked',
                prompt: 'You must agree to the terms and conditions'
              }
            ]
          }
        }
      }
    )

    // Create a Stripe client
    this._stripe = Stripe('pk_test_tPwSUvCAeBdKG6VGlpMbsdBa')

    // Create an instance of Elements
    var elements = this._stripe.elements()

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }
    // Create an instance of the card Element
    this.card = elements.create('card', {style: style})

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount('#card-element')

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    // Handle form submission
    var form = document.getElementById('payment-form')
    form && form.addEventListener('submit', function (event) {
      event.preventDefault()

      that._stripe.createToken(that.card).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          var errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
        } else {
          // FIXME would like to move this into Vue
          // but atm doing so with @click submits multiple times!

          // Send the token to your server
          that.create(result.token)
        }
      })
    })

    that.card.addEventListener('change', function (event) {
      if (event.value.postalCode) {
        that.setZipFilled(event.value.postalCode)
      }
      var displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.StripeElement {
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid;
  // box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;

  border-color: lightgrey;
}

.StripeElement--focus {
  // box-shadow: 0 1px 3px 0 #cfd7df;

  border-color: lightgreen;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>



// WEBPACK FOOTER //
// Signup.vue?f67005fe